enum OpportunityStatus {
    Open = 10,
    Closed = 91,
    Deleted = 100,
}

export const OpportunityStatusLabels: Record<number, string> = {
    [OpportunityStatus.Open]: 'Open',
    [OpportunityStatus.Closed]: 'Closed',
};

export default OpportunityStatus;
